/**
 * GrabPay Icon Data
 * Icon URL for GrabPay payment method (Singapore)
 */
export const GRABPAY_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/1DshnBdElQDmhfINo/abfc59a3c7cb7f3a89b2d32504971c39/GrabPay.svg';
